const CheckBoxLabel = ({ key = "1", label, checked, setter }) => {
  return (
    <div
      key={key}
      className="flex flex-row items-center justify-center gap-2"
    >
      <span className="text-xs truncate">{label}</span>
      <input
        type="checkbox"
        className="rounded-md border-gray-400 hover:cursor-pointer"
        checked={checked}
        onChange={(e) => setter(e.target.checked)
        }
      />
    </div>
  )
}

export default CheckBoxLabel;